import * as yup from 'yup';

import { COGNITO_PASSWORD_REGEXP } from '../../../services/cognito';

export default yup.object({
  username: yup.string().nullable().required('Please enter a username').label('Username').max(255),
  password: yup
    .string()
    .nullable()
    .required('Please enter a new password')
    .label('New password')
    .max(255)
    .matches(COGNITO_PASSWORD_REGEXP, 'New password does not meet requirements')
    .test('is-the-same', 'New password must match', (value, { parent }) => value === parent.confirm),
  confirm: yup
    .string()
    .nullable()
    .required('Please enter a confirm password')
    .label('Confirm password')
    .max(255)
    .matches(COGNITO_PASSWORD_REGEXP, 'Confirm password does not meet requirements')
    .test('is-the-same', 'Confirm password must match', (value, { parent }) => value === parent.password),
});
